import React from 'react';
import '../../FormBuilder.css';

const SelfieCameraElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'selfieCamera' && (
        <label className='titleTextLbl'>
            {component.fieldName || "selfieCamera"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default SelfieCameraElement;
